<div class="command-ribbon">
	<ng-container *ngFor="let command of posService.venueCommands | arrayFilter: { display: true }">
		<p-button
			pRipple
			styleClass="p-button-raised p-button-secondary command-ribbon-button m-2"
			[disabled]="command.disabled"
			(click)="posService.posCommandAction(command.name)"
		>
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="[command.faPrefix, command.faIcon]" size="lg" class="ms-1 me-2"></fa-icon>
					{{ command.name }}
				</div>
			</ng-template>
		</p-button>
	</ng-container>
</div>
